import { css, keyframes } from '@backyard-ui/styles';

const spin = keyframes({
  to: {
    transform: 'rotate(360deg)',
  },
});

const dash = keyframes({
  '0%': {
    strokeDasharray: '1, 150',
    strokeDashoffset: 0,
  },
  '50%': {
    strokeDasharray: '90, 150',
    strokeDashoffset: '-35',
  },
  '100%': {
    strokeDasharray: '90, 150',
    strokeDashoffset: '-124',
  },
});

const baseStyles = css({
  display: 'block',
  animation: `${spin} 2s linear infinite`,

  circle: {
    stroke: 'currentColor',
    strokeLinecap: 'round',

    animation: `${dash} 1.5s ease-in-out infinite`,
  },
  variants: {
    size: {
      xs: {
        width: '$3',
        height: '$3',
      },
      sm: {
        width: '$4',
        height: '$4',
      },
      md: {
        width: '$5',
        height: '$5',
      },
      lg: {
        width: '$6',
        height: '$6',
      },
      xl: {
        width: '$7',
        height: '$7',
      },
    },
    color: {
      black: {
        circle: {
          stroke: '$black',
        },
      },
      critical: {
        circle: {
          stroke: '$c500',
        },
      },
      info: {
        circle: {
          stroke: '$i500',
        },
      },
      primary: {
        circle: {
          stroke: '$p500',
        },
      },
      secondary: {
        circle: {
          stroke: '$s500',
        },
      },
      warning: {
        circle: {
          stroke: '$w500',
        },
      },
      white: {
        circle: {
          stroke: '$white',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default baseStyles;
